/**
 * Looking at a still: who is there, and where the phone is.
 *
 * The models run in the vision worker; this turns what they report into
 * decisions with the rules in geometry.ts.
 */
import { scan } from '../ml/tasks';
import { classify, faceBox, type Body, type Box, type Phone } from './geometry';

export interface Scene {
  w: number;
  h: number;
  bodies: Body[];
  phones: Phone[];
  /** The main person's face, if the pose model saw one. */
  face: Box | null;
  ms: number;
}

export async function findPhones(source: HTMLCanvasElement): Promise<Scene> {
  const t0 = performance.now();
  const { w, h, bodies, found } = await scan(source, 'capture');
  // The most prominent person is the one being photographed.
  const main = [...bodies].sort((a, b) => b.shoulderWidth - a.shoulderWidth)[0];
  return {
    w,
    h,
    bodies,
    phones: classify(found, bodies),
    face: main ? faceBox(main) : null,
    ms: Math.round(performance.now() - t0),
  };
}
